import Cookies from 'js-cookie';
import validator from '@/utils/validator';
import qs from 'qs';
import {
  RMB_UNIT,
  REDIRECT_NAME,
  PER_MINUTE,
  PER_HOUR,
  PER_DAY,
  BASE_URL,
  HOME_URL,
  UID_NAME,
  SHARE_FROM_NAME,
  ORIGIN_FROM_NAME,
  ALERT_MESSAGE_NAME,
  TOKEN_NAME,
} from '@/utils/constant';

/**
 * 驼峰转下划线
 * @param str
 * @returns {string}
 */
export function humpToUnderline(str) {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
}

/**
 * 获取JS 日期对象
 * @param source
 * @returns {*}
 */
export function getJsDateObject(source) {
  let time = source;
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if ((`${time}`).length === 10) time = parseInt(time, 10) * 1000;
    date = new Date(time);
  }
  return date;
}

/**
 * 左部填充
 * @param string
 * @param ch
 * @param len
 * @returns {string}
 */
export function leftPad(string, ch = '', len = 2) {
  let str = `${string}`;
  const diff = len - str.length;
  if (diff > 0) {
    str = new Array(diff + 1).join(ch) + str;
  }
  return str;
}

/**
 * 解析时间
 * @param source
 * @param cFormat
 * @returns {*}
 */
export function formatTime(source, cFormat = 'yyyy-MM-dd HH:ii:ss') {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat;
  const date = getJsDateObject(source);
  const formatObj = {
    y: date.getFullYear(),
    M: date.getMonth() + 1,
    d: date.getDate(),
    H: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  return format.replace(/(y|M|d|H|i|s|a)+/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value];
    if (result.length > 0 && value < 10) {
      value = `0${value}`;
    }
    return value || 0;
  });
}

export function formatMessageTime(source) {
  if (arguments.length === 0) {
    return null;
  }
  const currentTime = new Date();
  if (formatTime(source, 'yyyy-MM-dd') === formatTime(currentTime, 'yyyy-MM-dd')) {
    return formatTime(source, 'HH:ii');
  }
  if (formatTime(source, 'yyyy') === formatTime(currentTime, 'yyyy')) {
    return formatTime(source, 'MM-dd');
  }
  return formatTime(source, 'yyyy-MM-dd');
}

/**
 * 格式化价格
 * @param price
 * @returns {string}
 */
export function formatPrice(price) {
  return `${RMB_UNIT}${price}`;
}

/**
 * 格式化价格（含0元处理）
 * @param price
 * @returns {string}
 */
export function formatPriceWithFree(price) {
  if (price === 0) return '免费';
  return formatPrice(price);
}

/**
 * 格式化价格成HTML
 * @param number
 * @param formatFree
 * @returns {string}
 */
export function formatPriceHtml(number, formatFree = true) {
  let price = formatPriceWithFree(number);
  if (!formatFree) {
    price = formatPrice(number);
  }
  return price.replace(new RegExp(`^${RMB_UNIT}`), (...args) => `<span class="price-unit">${args[0]}</span>`);
}


/**
 * 时长转具体时间
 * @param string
 * @returns {number}
 */
export function durationToTime(string) {
  const array = string.toString().split(':');
  return (parseInt(array[0], 10) * 60) + parseInt(array[1], 10);
}

/**
 * 具体时间转时长
 * @param number
 * @returns {string}
 */
export function timeToDuration(number) {
  const time = parseInt(number, 10);
  const minutes = parseInt(time / 60, 10);
  const seconds = parseInt(time % 60, 10);
  return `${leftPad(minutes, '0')}:${leftPad(seconds, '0')}`;
}

/**
 * url encode
 * @param url
 * @returns {string}
 */
export function encodeUrl(url) {
  return encodeURIComponent(url.toString());
}

/**
 * url decode
 * @param url
 * @returns {string}
 */
export function decodeUrl(url) {
  return decodeURIComponent(url.toString());
}

/**
 * 解析query
 * @param str
 * @returns {{}}
 */
export function parseQuery(str) {
  const search = str.split('?');
  return qs.parse(search[1]);
}

/**
 * 生成query 参数
 * @param options
 * @returns {string}
 */
export function generateQuery(options) {
  const query = [];
  Object.keys(options).forEach((key) => {
    query.push(`${key}=${encodeUrl(options[key])}`);
  });
  return query.join('&');
}

/**
 * 获取解析后的query
 * @param options
 * @returns {{}}
 */
export function getQuery(options) {
  const obj = {};
  Object.keys(options).forEach((key) => {
    obj[key] = decodeUrl(options[key]);
  });
  return obj;
}

/**
 * 获取BaseUrl
 * @param url
 */
export function getBaseUrl(url) {
  const base = url.split('?');
  return base[0].replace(/\?[(&*)(\w*)(=*)(\w*)]*$/g, '');
}

/**
 * 生成URL
 * @param baseUrl
 * @param options
 * @returns {string}
 */
export function generateUrl(baseUrl, options) {
  return validator.isEmptyObj(options) ? baseUrl : `${baseUrl}?${generateQuery(options)}`;
}

/**
 * 追加query
 * @param str
 * @param options
 * @returns {string}
 */
export function appendQuery(str, options) {
  const base = getBaseUrl(str);
  const parse = parseQuery(str);
  const query = Object.assign({}, parse, options);
  return generateUrl(base, query);
}

/**
 * 数据打点
 * @param url
 * @param options
 */
export function collectData(url, options) {
  const img = document.createElement('img');
  img.src = generateUrl(url, options);
}

/**
 * 监控
 * @param error
 */
export function monitor(error) {
  if (!window.Sentry) return;
  window.Sentry.captureException(error);
}

/**
 * 设置监控用户
 * @param id
 */
export function setMonitorUser(id) {
  if (!window.Sentry) return;
  window.Sentry.configureScope((scope) => {
    scope.setUser({ id });
  });
}

/**
 * 简单加密
 * @param code
 * @returns {string}
 */
export function compile(code) {
  let result = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (let i = 1; i < code.length; i++) {
    result += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return encodeURI(result);
}

/**
 * 是否支持本地缓存storage
 * @returns {boolean}
 */
export function supperStorage() {
  try {
    window.localStorage.setItem('test', '');
    window.localStorage.removeItem('test');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * 从缓存中获取值
 * @param name
 * @returns {*}
 */
export function getFromStorage(name) {
  if (!supperStorage()) {
    return Cookies.get(`${name}`) || '';
  }
  return window.localStorage.getItem(`${name}`);
}

/**
 * 设置缓存
 * @param name
 * @param value
 * @returns {*}
 */
export function setToStorage(name, value) {
  if (!supperStorage()) {
    return Cookies.set(`${name}`, value, { path: '/' });
  }
  return window.localStorage.setItem(`${name}`, value);
}

/**
 * 删除缓存
 * @param name
 * @returns {*}
 */
export function removeFormStorage(name) {
  if (!supperStorage()) {
    return Cookies.remove(`${name}`, { path: '/' });
  }
  return window.localStorage.removeItem(`${name}`);
}

/**
 * 获取UID
 */
export function getUID() {
  return Cookies.get(`${UID_NAME}`) || '';
}

/**
 * 缓存验证
 * @param val
 * @returns {*}
 */
export function setAuth(val) {
  return setToStorage(`${TOKEN_NAME}`, val);
}

/**
 * 获取token
 */
export function getAuth() {
  return getFromStorage(`${TOKEN_NAME}`) || '';
}

/**
 * 获取分享来源
 * @returns {*}
 */
export function getShareFrom() {
  return Cookies.get(`${SHARE_FROM_NAME}`) || '';
}

/**
 * 设置分享来源
 * @param value
 * @returns {*}
 */
export function setShareFrom(value) {
  return Cookies.set(`${SHARE_FROM_NAME}`, value, { path: '/' });
}

/**
 * 获取页面来源
 * @returns {*}
 */
export function getOriginFrom() {
  return Cookies.get(`${ORIGIN_FROM_NAME}`) || '';
}

/**
 * 记录页面来源
 * @param value
 * @returns {*}
 */
export function setOriginFrom(value) {
  return Cookies.set(`${ORIGIN_FROM_NAME}`, value, { path: '/' });
}

/**
 * 获取弹窗信息
 * @returns {*}
 */
export function getAlertMessage() {
  return Cookies.get(`${ALERT_MESSAGE_NAME}`);
}

/**
 * 是否微信浏览器内
 * @returns {boolean}
 */
export function isWeiXinBrowser() {
  return (/micromessenger/i).test(window.navigator.userAgent);
}

/**
 * 获取用户UserAgent
 * @returns {string}
 */
export function getUserAgent() {
  return window.navigator.userAgent;
}

/**
 * 是否安卓系统
 * @returns {boolean}
 */
export function isAndroid() {
  const ua = getUserAgent();
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
}

/**
 * 是否iOs系统
 * @returns {boolean}
 */
export function isIOS() {
  const ua = getUserAgent();
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/**
 * 获取当前页面query
 * @returns {{}}
 */
export function getLocationQuery() {
  const { location } = window;
  const { search } = location;
  let query = {};
  if (search !== '') {
    query = parseQuery(search);
  }
  return query;
}

/**
 * 获取跳转的URL
 * @returns {string}
 */
export function getRedirectPath() {
  const { location } = window;
  const { pathname } = location;
  const blackList = [
    `${BASE_URL}/login`,
    `${BASE_URL}/login/mobile`,
    `${BASE_URL}/register`,
    `${BASE_URL}/password/reset`,
    `${BASE_URL}/settings/mobile`,
  ];
  const query = getLocationQuery();
  const { redirectTo } = query;
  if (redirectTo) return redirectTo;
  if (!blackList.includes(pathname)) {
    return pathname;
  }
  return `${HOME_URL}`;
}

/**
 * 缓存回退url
 */
export function storageRedirectPath() {
  const path = getRedirectPath();
  // 缓存回退url
  setToStorage(REDIRECT_NAME, path);
}

/**
 * 获取缓存的回退url
 * @returns {*}
 */
export function getStorageRedirect(redirectTo) {
  if (redirectTo && redirectTo !== '') {
    return redirectTo;
  }
  const result = getFromStorage(REDIRECT_NAME);
  if (result != null && result !== '') {
    return result;
  }
  return HOME_URL;
}

/**
 * 删除回退url
 */
export function removeStorageRedirect() {
  removeFormStorage(REDIRECT_NAME);
}

/**
 * 外链跳转
 * @param str
 */
export function locationHref(str) {
  storageRedirectPath();
  window.location.href = `${str}`;
}

/**
 * 获取产品主页路径
 * @param type
 * @returns {*}
 */
export function getProductIndexPath(type) {
  switch (type) {
    case 'course':
      return { name: 'Course' };
    default:
      return { name: 'Home' };
  }
}

/**
 * 获取产品路径
 * @param type
 * @param id
 * @returns {*}
 */
export function getProductPath(type, id) {
  switch (type) {
    case 'audio':
      return { name: 'AudioDetail', params: { id } };
    case 'course':
      return { name: 'CourseDetail', params: { id } };
    case 'project':
      return { name: 'ProjectDetail', params: { id } };
    case 'combo':
      return { name: 'ComboDetail', params: { id } };
    case 'audioCombo':
      return { name: 'ComboDetail', params: { id } };
    case 'courseCombo':
      return { name: 'ComboDetail', params: { id } };
    case 'groupbuyTeam':
      return { name: 'GroupBuyCreate', params: { id } };
    case 'groupbuyMember':
      return { name: 'GroupBuyTeamDetail', params: { id } };
    case 'reading':
      return { name: 'PlanDetail', params: { id } };
    default:
      return { name: 'Home' };
  }
}

/**
 * 解析时间
 * @param time
 * @returns {{days: string, hours: string, minutes: string, seconds: string}}
 */
export function parseTime(time) {
  const days = leftPad(Math.floor(time / PER_DAY), '0');
  const hours = leftPad(Math.floor((time % PER_DAY) / PER_HOUR), '0');
  const minutes = leftPad(Math.floor((time / PER_MINUTE) % 60), '0');
  const seconds = leftPad(Math.floor((time % PER_MINUTE) / 1000), '0');
  return {
    days,
    hours,
    minutes,
    seconds,
  };
}

/**
 * 数字转中文
 */
export function numberToCh(num) {
  const chNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
  return chNumChar[num];
}

/**
 * 首字母大写
 * @param word
 */
export function upperCaseFirst(word) {
  return word.replace(/^\S/, letter => letter.toUpperCase());
}

/**
 * 格式化手机，显示星号
 * @param mobile
 */
export function formatMobile(mobile) {
  return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

/**
 * px 转换vw
 * @param px
 * @param viewportWidth
 * @returns {number}
 */
export function pxToVw(px, viewportWidth = 750) {
  return px / (viewportWidth / 100);
}

/**
 * 判断是否外链
 * @param url
 * @returns {boolean}
 */
export function isExternalRequest(url) {
  return /^http(s):\/\//.test(url);
}

/**
 * 首字母大写
 * @param str
 * @returns {string}
 */
export function firstUpperCase(str) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, L => L.toUpperCase());
}

/**
 * 裁切字符串
 * @param str
 * @param reg
 */
export function sliceString(str, reg) {
  return str.match(new RegExp(reg));
}

/**
 * 判断是否在PC
 */
export function isPC() {
  const userAgentInfo = navigator.userAgent;
  const Agents = ['Android', 'iPhone', 'iPad', 'iPod', 'Windows Phone'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
